import { useMemo } from 'react'
import { extractQueryTokens } from '../../utils/filterByText'

/**
 * 검색어와 매치되는 텍스트 부분을 <mark> 로 감싸 강조.
 *
 * Props:
 *   text     — 원본 문자열
 *   query    — 검색어 (공백 구분 토큰들)
 *   className— mark 의 class (default 'search-hl')
 *
 * query 가 비어있으면 원본 텍스트 그대로 반환 (DOM 노드 추가 X).
 */
export default function HighlightText({ text, query, className = 'search-hl' }) {
  const result = useMemo(() => {
    if (text == null) return ''
    const s = String(text)
    const tokens = extractQueryTokens(query)
    if (!tokens.length) return s

    // 정규식 escape
    const escaped = tokens.map(t => t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
    // capture group 으로 split → 매치 부분이 odd index 에 들어감
    const re = new RegExp(`(${escaped.join('|')})`, 'gi')
    const parts = s.split(re)
    return parts.map((p, i) =>
      i % 2 === 1
        ? <mark key={i} className={className}>{p}</mark>
        : p
    )
  }, [text, query, className])

  return <>{result}</>
}
